export default __webpack_public_path__ + "static/media/PLAYER SALARY.2d857b5a.png";